import { Logo } from "../components/Logo";
import { SITE, waLink } from "../data/site";
import { Reveal } from "../components/Reveal";

const SECTIONS = [
  {
    title: "1. Quem é o responsável pelos seus dados",
    text: `Este site é operado por ${SITE.licenciado}, Licenciado Autorizado iGreen Energy (ID ${SITE.licenciadoId}). É ele quem recebe, guarda e usa os dados que você envia pelos formulários deste site, exclusivamente para te atender.`,
  },
  {
    title: "2. Quais dados coletamos",
    text: "Nome, e-mail, WhatsApp, estado (UF), faixa de valor da conta de luz e o serviço de seu interesse, informados por você nos formulários do site. Também usamos cookies de medição e de publicidade, conforme a sua escolha no aviso de cookies.",
  },
  {
    title: "3. Para que usamos",
    text: "Para entrar em contato com você pelo WhatsApp ou e-mail, confirmar se a sua região é atendida, apresentar o desconto disponível e conduzir o seu cadastro na Conexão Green da iGreen Energy. Não vendemos nem compartilhamos seus dados com terceiros fora desse atendimento.",
  },
  {
    title: "4. Cadastro na iGreen Energy",
    text: "Ao prosseguir com a contratação, o cadastro é feito no sistema oficial da iGreen Energy, vinculado ao licenciado acima. Nessa etapa, os dados necessários (documento, conta de luz e selfie) seguem também a política de privacidade da iGreen Energy.",
  },
  {
    title: "5. Cookies",
    text: "Usamos cookies para medir a audiência do site e mostrar anúncios para quem já nos visitou. Você pode aceitar ou recusar no aviso exibido na primeira visita, e pode apagar os cookies do seu navegador a qualquer momento.",
  },
  {
    title: "6. Seus direitos (LGPD)",
    text: `Você pode pedir a confirmação, o acesso, a correção ou a exclusão dos seus dados a qualquer momento, falando diretamente com ${SITE.licenciado} pelo WhatsApp deste site. Atendemos à Lei Geral de Proteção de Dados (Lei nº 13.709/2018).`,
  },
  {
    title: "7. Guarda e segurança",
    text: "Os dados ficam armazenados em ambiente seguro e são acessados apenas pelo licenciado para o atendimento. Quando você pedir a exclusão, os dados são removidos.",
  },
];

export default function Privacidade() {
  return (
    <div className="min-h-screen bg-[#04120E]" data-testid="privacidade-page">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#04120E]/85 border-b border-white/10">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Logo />
          <a href="/" data-testid="privacidade-back-link" className="text-sm text-emerald-100/60 hover:text-[#00E676] transition-colors">
            Voltar ao site
          </a>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <Reveal>
          <p className="text-xs font-mono2 uppercase tracking-[0.25em] text-[#00E676] mb-4">Documento legal</p>
          <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-white tracking-tight">
            Política de <span className="text-[#00E676]">Privacidade</span>
          </h1>
          <p className="mt-4 text-sm text-emerald-100/55 leading-relaxed max-w-2xl">
            Última atualização: novembro de 2026. Aqui explicamos, sem letra miúda, como os seus dados são tratados neste site.
          </p>
        </Reveal>
        <div className="mt-12 space-y-8">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <section className="rounded-2xl border border-white/10 bg-[#0B261E]/60 p-7">
                <h2 className="font-heading text-lg font-bold text-white">{s.title}</h2>
                <p className="mt-3 text-sm text-emerald-100/60 leading-relaxed">{s.text}</p>
              </section>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <p className="mt-12 text-sm text-emerald-100/50 leading-relaxed border-t border-white/10 pt-8">
            Ficou com alguma dúvida sobre os seus dados?{" "}
            <a href={waLink("Oi, quero falar sobre a política de privacidade do site.")} target="_blank" rel="noopener noreferrer" className="text-[#00E676] underline underline-offset-4" data-testid="privacidade-whatsapp-link">
              Fale comigo no WhatsApp
            </a>
            .
          </p>
        </Reveal>
      </main>
    </div>
  );
}
